import { NAME } from './constants';

export const SET_SEARCH_VALUE = `${NAME}.SET_SEARCH_VALUE`;
export const SET_LOADING = `${NAME}.SET_LOADING`;
export const SET_ACTION_POPUP_VISIBLE_UID = `${NAME}.SET_ACTION_POPUP_VISIBLE_UID`;
